// Consolidated Data Center Information for All Cities
export const ALL_DATA_CENTERS = {
  indore: {
    id: 1,
    city: "Indore",
    state: "Madhya Pradesh",
    latitude: 22.7585731,
    longitude: 75.8662183,
    facilities: [
      { id: "QRDC1", latitude: 22.7585731, longitude: 75.8662183 },
      { id: "QRDC2", latitude: 22.7261295, longitude: 75.8784263 },
    ],
    title:
      "Data Centers in Indore | Reliable Colocation & Hosting Services | QuantaRock Systems",
    metaDescription:
      "Discover top-tier data centers in Indore offering secure colocation, dedicated servers, and hosting solutions. QuantaRock Systems provides state-of-the-art infrastructure with 99.9% uptime, advanced security, and expert support for businesses in Indore, Madhya Pradesh.",
    keywords:
      "quantarock indore, indore data center, indore colocation, indore dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems indore, indore IT infrastructure, secure data center, tier 3 data center, managed hosting",
    h1: "Premium Data Centers in Indore for Unmatched Reliability",
    intro:
      "QuantaRock Systems offers cutting-edge data center solutions in Indore, Madhya Pradesh. Our facility provides secure colocation services, dedicated servers, and advanced hosting options designed to meet the growing demands of businesses in Indore and surrounding areas.",
    features: [
      {
        title: "State-of-the-Art Infrastructure",
        description:
          "Our Indore data center features redundant power systems, advanced cooling technology, and 24/7 monitoring to ensure maximum uptime and performance.",
      },
      {
        title: "Enhanced Security Measures",
        description:
          "Multi-layered security including biometric access, CCTV surveillance, and fire suppression systems protect your valuable data and equipment.",
      },
      {
        title: "High-Speed Connectivity",
        description:
          "Multiple carrier-neutral connections provide low-latency, high-bandwidth internet access to support your critical business applications.",
      },
      {
        title: "Expert Technical Support",
        description:
          "Our team of certified professionals offers round-the-clock support, remote hands services, and on-site assistance whenever you need it.",
      },
    ],
    services: [
      "Colocation Services",
      "Dedicated Servers",
      "Cloud Hosting",
      "Disaster Recovery",
      "Network Security",
      "24/7 Monitoring",
    ],
    location: {
      address:
        "444, Shyam Nagar(main), Sukhliya Indore, Madhya Pradesh, India - 452010",
      coordinates: { lat: 22.7585731, lng: 75.8662183 },
    },
    cta: "Get a Custom Quote for Data Center Services in Indore",
  },
  pune: {
    id: 2,
    city: "Pune",
    state: "Maharashtra",
    latitude: 18.5204,
    longitude: 73.8567,
    title:
      "Data Centers in Pune | Secure Colocation & Hosting Solutions | QuantaRock Systems",
    metaDescription:
      "Need data center services in Pune? QuantaRock Systems delivers colocation, dedicated servers, and enterprise-grade hosting through our data center partner network, with advanced security, scalability, and expert support for Pune businesses.",
    keywords:
      "quantarock pune, pune data center, pune colocation, pune dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems pune, pune IT infrastructure, secure data center, tier 3 data center, managed hosting",
    h1: "Leading Data Centers in Pune for Business Growth",
    intro:
      "Located in the heart of Maharashtra's IT hub, Pune is one of the cities where QuantaRock Systems deploys colocation and hosting services on demand through our data center partner network. We keep your business connected, secure, and scalable in the competitive Pune market — without the lead time of building out infrastructure yourself.",
    features: [
      {
        title: "Enterprise-Grade Infrastructure",
        description:
          "We deploy into Tier 3-standard facilities with redundant systems, delivering 99.9% uptime and handling high-traffic workloads effortlessly.",
      },
      {
        title: "Comprehensive Security",
        description:
          "Advanced security protocols including mantraps, video surveillance, and environmental monitoring safeguard your critical infrastructure.",
      },
      {
        title: "Carrier Diversity",
        description:
          "Multiple internet service providers and dark fiber options ensure reliable connectivity and business continuity for Pune enterprises.",
      },
      {
        title: "Scalable Solutions",
        description:
          "From single racks to full cages, our flexible colocation options grow with your business needs in the dynamic Pune market.",
      },
    ],
    services: [
      "Colocation Services",
      "Dedicated Servers",
      "Hybrid Cloud Solutions",
      "Backup & Recovery",
      "Managed Security",
      "Remote Management",
    ],
    location: {
      address: "Pune, Maharashtra, India - 411001",
      coordinates: { lat: 18.5204, lng: 73.8567 },
    },
    cta: "Explore Data Center Solutions in Pune Today",
  },
  bangalore: {
    id: 3,
    city: "Bangalore",
    state: "Karnataka",
    latitude: 13.1509444,
    longitude: 77.7068889,
    facilities: [
      { id: "QRDC3", latitude: 13.1509444, longitude: 77.7068889 },
    ],
    title:
      "Data Centers in Bangalore | Advanced Colocation & Hosting Services | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems provides world-class data centers in Bangalore, Karnataka. Benefit from secure colocation, dedicated servers, and cutting-edge hosting solutions with 99.9% uptime and expert support for Bangalore businesses.",
    keywords:
      "quantarock bangalore, bangalore data center, bangalore colocation, bangalore dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems bangalore, bangalore IT infrastructure, secure data center, tier 3 data center, managed hosting",
    h1: "State-of-the-Art Data Centers in Bangalore",
    intro:
      "As India's Silicon Valley, Bangalore demands top-tier data center infrastructure. QuantaRock Systems delivers premium colocation and hosting services in Bangalore, combining advanced technology with unparalleled reliability to support your digital transformation.",
    features: [
      {
        title: "Next-Generation Technology",
        description:
          "Our Bangalore facility incorporates the latest in data center technology, including AI-powered cooling and predictive maintenance systems.",
      },
      {
        title: "Fortified Security",
        description:
          "Military-grade security measures protect your data, including biometric authentication, 24/7 armed guards, and advanced intrusion detection.",
      },
      {
        title: "Ultra-Low Latency",
        description:
          "Strategic location in Bangalore's tech corridor ensures minimal latency for high-performance applications and real-time data processing.",
      },
      {
        title: "Green Energy Solutions",
        description:
          "Eco-friendly design with renewable energy integration and efficient cooling systems for sustainable data center operations.",
      },
    ],
    services: [
      "Colocation Services",
      "Dedicated Servers",
      "Edge Computing",
      "AI & ML Hosting",
      "Data Analytics Platform",
      "Green Hosting",
    ],
    location: {
      address: "Bangalore, Karnataka, India - 560001",
      coordinates: { lat: 13.1509444, lng: 77.7068889 },
    },
    cta: "Discover Data Center Excellence in Bangalore",
  },
  mumbai: {
    id: 4,
    city: "Mumbai",
    state: "Maharashtra",
    latitude: 19.1411567,
    longitude: 73.0059673,
    facilities: [
      { id: "QRDC6", latitude: 19.1411567, longitude: 73.0059673 },
      { id: "QRDC8", latitude: 19.1202354, longitude: 72.9134403 },
    ],
    title:
      "Data Centers in Mumbai | Premium Colocation & Cloud Hosting Services | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems operates premier data centers in Mumbai. Experience world-class colocation, dedicated servers, and enterprise hosting with 99.99% uptime, advanced security, and 24/7 expert support for Mumbai businesses.",
    keywords:
      "quantarock mumbai, mumbai data center, mumbai colocation, mumbai dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems mumbai, mumbai IT infrastructure, secure data center, tier 4 data center, managed hosting",
    h1: "Premium Data Centers in Mumbai for Global Connectivity",
    intro:
      "QuantaRock Systems' Mumbai data center serves as the gateway to India's financial hub. Our carrier-neutral facility offers superior connectivity, world-class infrastructure, and enterprise-grade hosting solutions for businesses operating in Mumbai and across India.",
    features: [
      {
        title: "Tier 4 Infrastructure",
        description:
          "Our Mumbai facility meets Tier 4 standards with fully redundant systems, ensuring maximum reliability and minimal downtime for mission-critical operations.",
      },
      {
        title: "Multi-Carrier Connectivity",
        description:
          "Direct peering with global carriers and local ISPs ensures exceptional network performance and business continuity for Mumbai enterprises.",
      },
      {
        title: "Advanced Compliance",
        description:
          "Full compliance with RBI, SEBI, and international data protection standards for financial services and regulated industries.",
      },
      {
        title: "24/7 Hands-On Support",
        description:
          "Dedicated technical teams with expertise in finance-grade infrastructure provide round-the-clock professional support.",
      },
    ],
    services: [
      "Enterprise Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Disaster Recovery",
      "Compliance Solutions",
      "Network Security",
    ],
    location: {
      address: "Mumbai, Maharashtra, India - 400001",
      coordinates: { lat: 19.1411567, lng: 73.0059673 },
    },
    cta: "Connect with QuantaRock in Mumbai Today",
  },
  delhi: {
    id: 5,
    city: "Delhi",
    state: "Delhi",
    latitude: 28.7041,
    longitude: 77.1025,
    title:
      "Data Centers in Delhi NCR | Secure Hosting & Colocation | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy enterprise data center capacity in Delhi NCR on demand. Access colocation, dedicated servers, and scalable cloud hosting with high uptime and strong security for government and corporate clients.",
    keywords:
      "quantarock delhi, delhi data center, delhi colocation, delhi dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems delhi, delhi IT infrastructure, secure data center, government hosting, managed hosting",
    h1: "Enterprise Data Centers in Delhi for Government & Corporate Solutions",
    intro:
      "Located in India's capital, Delhi NCR is a priority deployment city for QuantaRock Systems, serving government agencies and large enterprises. Through our data center partner network, we can provision infrastructure designed to meet government-grade security standards, strong connectivity, and national IT policy compliance requirements.",
    features: [
      {
        title: "Government-Grade Security",
        description:
          "Deployments are designed to meet DoT and government security expectations, with multi-layered security protocols, surveillance, and restricted access controls at partner facilities.",
      },
      {
        title: "Redundant Infrastructure",
        description:
          "N+2 redundancy on all critical systems ensures continuous operations and zero single points of failure.",
      },
      {
        title: "Direct Peering with NKN",
        description:
          "Connectivity with National Knowledge Network for seamless integration with government and educational institutions.",
      },
      {
        title: "Certified Compliance",
        description:
          "We work with ISO 27001 and ISO 9001-certified partner facilities and support the compliance documentation regulated projects require.",
      },
    ],
    services: [
      "Government Colocation",
      "Dedicated Servers",
      "Secure Cloud Hosting",
      "Compliance Hosting",
      "Disaster Recovery",
      "24/7 Support",
    ],
    location: {
      address: "Delhi, Delhi, India - 110001",
      coordinates: { lat: 28.7041, lng: 77.1025 },
    },
    cta: "Explore Government & Enterprise Solutions in Delhi",
  },
  hyderabad: {
    id: 6,
    city: "Hyderabad",
    state: "Telangana",
    latitude: 17.3849,
    longitude: 78.4678,
    title:
      "Data Centers in Hyderabad | Scalable Cloud & Colocation Services | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy cutting-edge data center infrastructure in Hyderabad, Telangana on demand. Colocation, dedicated servers, and cloud hosting designed for tech startups and enterprises, with a 99.99% uptime guarantee.",
    keywords:
      "quantarock hyderabad, hyderabad data center, hyderabad colocation, hyderabad dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems hyderabad, hyderabad IT infrastructure, secure data center, startup hosting, managed hosting",
    h1: "Modern Data Centers in Hyderabad for Tech Innovation",
    intro:
      "QuantaRock Systems brings world-class data center infrastructure to Hyderabad's thriving IT ecosystem on demand. Through our partner network, we deploy solutions purpose-built for tech startups and enterprises, offering scalability, exceptional uptime, and startup-friendly pricing.",
    features: [
      {
        title: "Startup-Friendly Infrastructure",
        description:
          "Flexible rack and cage options with pay-as-you-grow pricing, perfect for scaling tech startups and growing enterprises.",
      },
      {
        title: "Developer-Centric Design",
        description:
          "Direct console access, flexible API integrations, and developer-friendly cloud solutions for rapid deployment.",
      },
      {
        title: "Innovation Hub Connectivity",
        description:
          "Direct peering with Hyderabad's tech parks and startup hubs for seamless internal network connectivity.",
      },
      {
        title: "Green Data Center",
        description:
          "We prioritize renewable-energy-powered partner facilities with advanced cooling systems for eco-conscious tech companies.",
      },
    ],
    services: [
      "Startups Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "API Access",
      "Managed Services",
      "Tech Support",
    ],
    location: {
      address: "Hyderabad, Telangana, India - 500001",
      coordinates: { lat: 17.3849, lng: 78.4678 },
    },
    cta: "Scale Your Business with QuantaRock in Hyderabad",
  },
  kolkata: {
    id: 7,
    city: "Kolkata",
    state: "West Bengal",
    latitude: 22.5726,
    longitude: 88.3639,
    title:
      "Data Centers in Kolkata | Enterprise Colocation & Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems delivers enterprise-grade data center services in Kolkata, West Bengal on demand. Colocation, dedicated servers, and cloud hosting with regional expertise for Eastern India.",
    keywords:
      "quantarock kolkata, kolkata data center, kolkata colocation, kolkata dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems kolkata, kolkata IT infrastructure, secure data center, eastern india, managed hosting",
    h1: "Enterprise Data Centers in Kolkata for Eastern India",
    intro:
      "QuantaRock Systems serves Eastern India's growing tech and financial sectors with on-demand data center deployment in Kolkata. Through our partner network, we provide regional expertise, local support, and enterprise-class infrastructure for businesses across West Bengal and surrounding regions.",
    features: [
      {
        title: "Regional Connectivity Hub",
        description:
          "Strategic location connecting Eastern India to national and international networks with optimal routing for regional businesses.",
      },
      {
        title: "Financial Sector Expertise",
        description:
          "Specialized infrastructure for banking, insurance, and financial services with compliance expertise for Eastern India operations.",
      },
      {
        title: "Redundant Infrastructure",
        description:
          "N+1 redundancy on all critical systems ensuring uninterrupted service for regional enterprises.",
      },
      {
        title: "Local Technical Support",
        description:
          "Regional technical team with deep understanding of Eastern India's business requirements and challenges.",
      },
    ],
    services: [
      "Enterprise Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Regional Networking",
      "Financial Services Hosting",
      "24/7 Regional Support",
    ],
    location: {
      address: "Kolkata, West Bengal, India - 700001",
      coordinates: { lat: 22.5726, lng: 88.3639 },
    },
    cta: "Connect with QuantaRock in Kolkata Today",
  },
  chennai: {
    id: 8,
    city: "Chennai",
    state: "Tamil Nadu",
    latitude: 12.8215985,
    longitude: 80.2227604,
    facilities: [
      { id: "QRDC7", latitude: 12.8215985, longitude: 80.2227604 },
    ],
    title:
      "Data Centers in Chennai | Secure Hosting & Colocation Services | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems provides advanced data centers in Chennai, Tamil Nadu. Premium colocation, dedicated servers, and cloud hosting solutions for Southern India's IT and automotive sectors.",
    keywords:
      "quantarock chennai, chennai data center, chennai colocation, chennai dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems chennai, chennai IT infrastructure, secure data center, southern india, managed hosting",
    h1: "Premium Data Centers in Chennai for Southern India",
    intro:
      "QuantaRock Systems' Chennai data center serves Southern India's thriving IT ecosystem and manufacturing sectors. Our facility delivers world-class infrastructure, seamless connectivity, and sector-specific expertise for businesses across Tamil Nadu and neighboring states.",
    features: [
      {
        title: "Manufacturing Sector Optimization",
        description:
          "Specialized infrastructure supporting automotive and manufacturing industry requirements with real-time connectivity needs.",
      },
      {
        title: "Tier 3 Standards",
        description:
          "Built to international Tier 3 standards with N+1 redundancy ensuring maximum reliability for critical operations.",
      },
      {
        title: "Coastal Resilience",
        description:
          "Advanced environmental controls and resilient design protecting infrastructure from coastal climate challenges.",
      },
      {
        title: "Automotive Ecosystem Integration",
        description:
          "Direct connectivity to major automotive OEMs and suppliers across Tamil Nadu for seamless data exchange.",
      },
    ],
    services: [
      "Manufacturing Hosting",
      "Dedicated Servers",
      "Cloud Hosting",
      "Sector-Specific Solutions",
      "High-Speed Connectivity",
      "Managed Services",
    ],
    location: {
      address: "Chennai, Tamil Nadu, India - 600001",
      coordinates: { lat: 12.8215985, lng: 80.2227604 },
    },
    cta: "Explore Data Center Solutions in Chennai",
  },
  jaipur: {
    id: 9,
    city: "Jaipur",
    state: "Rajasthan",
    latitude: 26.9124,
    longitude: 75.7873,
    title:
      "Data Centers in Jaipur | Scalable Colocation & Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems delivers modern data center services in Jaipur, Rajasthan on demand. Affordable colocation, dedicated servers, and cloud hosting for growing businesses in Northern India with competitive pricing.",
    keywords:
      "quantarock jaipur, jaipur data center, jaipur colocation, jaipur dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems jaipur, jaipur IT infrastructure, secure data center, affordable hosting, managed hosting",
    h1: "Scalable Data Centers in Jaipur for Growing Businesses",
    intro:
      "QuantaRock Systems brings affordable data center infrastructure to Jaipur on demand through our partner network. Deployments are designed for SMEs and growing enterprises, offering scalable solutions, competitive pricing, and excellent support for businesses across Rajasthan.",
    features: [
      {
        title: "Cost-Effective Solutions",
        description:
          "Affordable colocation and hosting options designed for SMEs and startups without compromising on quality or reliability.",
      },
      {
        title: "Scalable Infrastructure",
        description:
          "Flexible capacity options allowing businesses to scale from small deployments to enterprise-grade solutions.",
      },
      {
        title: "Northern India Connectivity",
        description:
          "Strategic location providing excellent connectivity to Northern and Central Indian markets.",
      },
      {
        title: "Business-Friendly Support",
        description:
          "Responsive support team understanding the needs of SMEs and growing businesses.",
      },
    ],
    services: [
      "SME Colocation",
      "Dedicated Servers",
      "Shared Hosting",
      "Cloud Solutions",
      "Budget-Friendly Plans",
      "Growth Support",
    ],
    location: {
      address: "Jaipur, Rajasthan, India - 302001",
      coordinates: { lat: 26.9124, lng: 75.7873 },
    },
    cta: "Scale Your Business with QuantaRock in Jaipur",
  },
  ahmedabad: {
    id: 10,
    city: "Ahmedabad",
    state: "Gujarat",
    latitude: 23.0592249,
    longitude: 72.5179758,
    facilities: [
      { id: "QRDC4", latitude: 23.0592249, longitude: 72.5179758 },
      { id: "QRDC5", latitude: 23.1143874, longitude: 72.5361237 },
    ],
    title:
      "Data Centers in Ahmedabad | Business Colocation & Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems provides enterprise data centers in Ahmedabad, Gujarat. Premium colocation, dedicated servers, and cloud hosting for Western India's textile, diamond, and IT industries.",
    keywords:
      "quantarock ahmedabad, ahmedabad data center, ahmedabad colocation, ahmedabad dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems ahmedabad, ahmedabad IT infrastructure, secure data center, western india, managed hosting",
    h1: "Enterprise Data Centers in Ahmedabad for Western India",
    intro:
      "QuantaRock Systems' Ahmedabad data center serves Western India's diverse industrial and IT sectors. Our facility provides specialized infrastructure for textile, diamond, automotive, and IT industries with sector-specific expertise and excellent regional connectivity.",
    features: [
      {
        title: "Multi-Sector Expertise",
        description:
          "Specialized infrastructure supporting textile, diamond, pharmaceutical, and IT industries with industry-specific requirements.",
      },
      {
        title: "Tier 3 Facility",
        description:
          "Enterprise-grade infrastructure with 99.99% uptime guarantee and full redundancy on all critical systems.",
      },
      {
        title: "Western India Hub",
        description:
          "Strategic location providing excellent connectivity to Western India and direct access to Gujarat's business ecosystem.",
      },
      {
        title: "Industry Integration",
        description:
          "Direct connectivity to major industrial hubs and trading centers across Gujarat.",
      },
    ],
    services: [
      "Industry Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Sector Solutions",
      "High-Availability Setup",
      "Enterprise Support",
    ],
    location: {
      address: "Ahmedabad, Gujarat, India - 380001",
      coordinates: { lat: 23.0592249, lng: 72.5179758 },
    },
    cta: "Connect with QuantaRock in Ahmedabad",
  },
  chandigarh: {
    id: 11,
    city: "Chandigarh",
    state: "Chandigarh",
    latitude: 30.7333,
    longitude: 76.7794,
    title:
      "Data Centers in Chandigarh | Government & Enterprise Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy secure data center capacity in Chandigarh on demand. Government-grade hosting, dedicated servers, and enterprise solutions for Northern India with strong security and compliance support.",
    keywords:
      "quantarock chandigarh, chandigarh data center, chandigarh colocation, chandigarh dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems chandigarh, chandigarh IT infrastructure, secure data center, government hosting, managed hosting",
    h1: "Government-Grade Data Centers in Chandigarh",
    intro:
      "QuantaRock Systems deploys data center infrastructure in Chandigarh for government agencies, educational institutions, and enterprises. Through our partner network, we provision facilities designed to meet government security standards, seamless NKN integration, and specialized support for public sector and educational organizations.",
    features: [
      {
        title: "Government Compliance",
        description:
          "Deployments are designed to meet government security standards and compliance requirements for hosting critical government and educational systems.",
      },
      {
        title: "NKN Integration",
        description:
          "Direct connectivity with National Knowledge Network for seamless integration with government and educational institutions.",
      },
      {
        title: "Education Sector Ready",
        description:
          "Specialized infrastructure supporting universities, colleges, and educational technology deployments.",
      },
      {
        title: "Security Certification",
        description:
          "We work with ISO 27001-certified partner facilities and support the specialized security protocols sensitive data hosting requires.",
      },
    ],
    services: [
      "Government Hosting",
      "Educational Institution Colocation",
      "Dedicated Servers",
      "Secure Cloud Hosting",
      "Compliance Solutions",
      "NKN Connectivity",
    ],
    location: {
      address: "Chandigarh, Chandigarh, India - 160001",
      coordinates: { lat: 30.7333, lng: 76.7794 },
    },
    cta: "Explore Secure Hosting Solutions in Chandigarh",
  },
  noida: {
    id: 12,
    city: "Noida",
    state: "Uttar Pradesh",
    latitude: 28.5355,
    longitude: 77.391,
    title:
      "Data Centers in Noida NCR | Enterprise & Startup Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems delivers premium data center services in Noida, Greater Noida NCR on demand. Enterprise colocation, dedicated servers, and cloud hosting for the Delhi NCR region with fast deployment and flexible solutions.",
    keywords:
      "quantarock noida, noida data center, noida colocation, noida dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems noida, noida IT infrastructure, secure data center, ncr region, managed hosting",
    h1: "Premium Data Centers in Noida NCR Region",
    intro:
      "QuantaRock Systems serves the Delhi NCR region with on-demand data center deployment in Noida, offering enterprise-class infrastructure and startup-friendly solutions. Through our partner network, we provide flexible capacity, rapid deployment, and excellent support for businesses ranging from startups to enterprises.",
    features: [
      {
        title: "NCR Regional Hub",
        description:
          "Strategic location in Noida serving the entire Delhi NCR region with direct connectivity to major business centers.",
      },
      {
        title: "Fast Deployment",
        description:
          "Rapid onboarding processes and flexible infrastructure allowing businesses to deploy within hours.",
      },
      {
        title: "Startup-Friendly",
        description:
          "Flexible rack options, affordable pricing, and startup-focused services for emerging companies.",
      },
      {
        title: "Enterprise Grade",
        description:
          "Enterprise-class infrastructure with 99.99% uptime SLA for mission-critical business operations.",
      },
    ],
    services: [
      "Enterprise Colocation",
      "Startup Hosting",
      "Dedicated Servers",
      "Cloud Hosting",
      "Flexible Solutions",
      "Fast Support",
    ],
    location: {
      address: "Noida, Uttar Pradesh, India - 201301",
      coordinates: { lat: 28.5355, lng: 77.391 },
    },
    cta: "Launch Your Business with QuantaRock in Noida",
  },
  bhopal: {
    id: 13,
    city: "Bhopal",
    state: "Madhya Pradesh",
    latitude: 23.1815,
    longitude: 79.9864,
    title:
      "Data Centers in Bhopal | Enterprise Colocation & Hosting Services | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy premium data center services in Bhopal, Madhya Pradesh on demand. Secure colocation, dedicated servers, and cloud hosting solutions for Central India businesses.",
    keywords:
      "quantarock bhopal, bhopal data center, bhopal colocation, bhopal dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems bhopal, bhopal IT infrastructure, secure data center, central india, managed hosting",
    h1: "Premium Data Centers in Bhopal for Central India",
    intro:
      "QuantaRock Systems serves Central India's growing business sectors with on-demand data center deployment in Bhopal. Through our partner network, we offer secure colocation, dedicated servers, and cloud hosting solutions designed for enterprises and SMEs in Madhya Pradesh and neighboring regions.",
    features: [
      {
        title: "Central India Connectivity",
        description:
          "Strategic location providing excellent connectivity to Central India markets and major business centers in the region.",
      },
      {
        title: "Enterprise-Grade Infrastructure",
        description:
          "Built to Tier 3 standards with redundant systems ensuring 99.9% uptime for critical business operations.",
      },
      {
        title: "Cost-Effective Solutions",
        description:
          "Affordable colocation and hosting options designed for growing businesses in Central India.",
      },
      {
        title: "Regional Technical Support",
        description:
          "Local support team with expertise in Central India's business landscape and requirements.",
      },
    ],
    services: [
      "Enterprise Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Regional Networking",
      "Disaster Recovery",
      "24/7 Support",
    ],
    location: {
      address: "Bhopal, Madhya Pradesh, India - 462001",
      coordinates: { lat: 23.1815, lng: 79.9864 },
    },
    cta: "Explore Data Center Solutions in Bhopal",
  },
  raipur: {
    id: 14,
    city: "Raipur",
    state: "Chhattisgarh",
    latitude: 21.2506,
    longitude: 81.6296,
    title:
      "Data Centers in Raipur | Secure Colocation & Enterprise Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems delivers modern data center services in Raipur, Chhattisgarh on demand. Premium colocation, dedicated servers, and cloud hosting for Eastern Central India businesses.",
    keywords:
      "quantarock raipur, raipur data center, raipur colocation, raipur dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems raipur, raipur IT infrastructure, secure data center, eastern central india, managed hosting",
    h1: "Modern Data Centers in Raipur for Eastern Central India",
    intro:
      "QuantaRock Systems brings world-class data center infrastructure to Raipur on demand through our partner network. Deployments are designed to serve Chhattisgarh's mining, manufacturing, and IT sectors with secure colocation, dedicated servers, and excellent regional connectivity.",
    features: [
      {
        title: "Mining & Manufacturing Support",
        description:
          "Specialized infrastructure supporting mining, steel, and manufacturing industries with real-time connectivity needs.",
      },
      {
        title: "Tier 3 Standards",
        description:
          "Built to international standards with N+1 redundancy ensuring maximum reliability for critical operations.",
      },
      {
        title: "Eastern Central India Hub",
        description:
          "Strategic location connecting Chhattisgarh to national and international networks with optimal routing.",
      },
      {
        title: "Industry Expertise",
        description:
          "Deep understanding of Eastern Central India's industrial requirements and business landscape.",
      },
    ],
    services: [
      "Industrial Sector Hosting",
      "Dedicated Servers",
      "Cloud Hosting",
      "High-Availability Setup",
      "Network Security",
      "Enterprise Support",
    ],
    location: {
      address: "Raipur, Chhattisgarh, India - 492001",
      coordinates: { lat: 21.2506, lng: 81.6296 },
    },
    cta: "Connect with QuantaRock in Raipur Today",
  },
  surat: {
    id: 15,
    city: "Surat",
    state: "Gujarat",
    latitude: 21.1702,
    longitude: 72.8311,
    title:
      "Data Centers in Surat | Diamond Industry & Enterprise Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy specialized data center services in Surat, Gujarat on demand. Colocation and hosting solutions for diamond, textile, petrochemical, and IT industries.",
    keywords:
      "quantarock surat, surat data center, surat colocation, surat dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems surat, surat IT infrastructure, secure data center, diamond industry, managed hosting",
    h1: "Specialized Data Centers in Surat for Diamond & Industry",
    intro:
      "QuantaRock Systems serves the diamond, textile, petrochemical, and IT industries with on-demand data center deployment in Surat. Through our partner network, we provide specialized infrastructure with high-speed connectivity designed for Surat's diverse industrial and commercial ecosystem.",
    features: [
      {
        title: "Diamond Industry Optimized",
        description:
          "Specialized security and connectivity infrastructure designed specifically for the diamond and jewelry industry.",
      },
      {
        title: "Multi-Industry Support",
        description:
          "Expertise supporting diamond, textile, petrochemical, and IT sectors with industry-specific requirements.",
      },
      {
        title: "High-Speed Connectivity",
        description:
          "Multiple carrier connections ensuring ultra-fast data transfer for time-sensitive commercial operations.",
      },
      {
        title: "Enterprise-Grade Security",
        description:
          "Advanced security protocols specifically designed for high-value inventory tracking and trading operations.",
      },
    ],
    services: [
      "Diamond Trade Hosting",
      "Dedicated Servers",
      "Cloud Hosting",
      "High-Speed Connectivity",
      "Secure Vaults",
      "Enterprise Support",
    ],
    location: {
      address: "Surat, Gujarat, India - 395001",
      coordinates: { lat: 21.1702, lng: 72.8311 },
    },
    cta: "Explore Specialized Data Center Solutions in Surat",
  },
  nashik: {
    id: 16,
    city: "Nashik",
    state: "Maharashtra",
    latitude: 19.9975,
    longitude: 73.7898,
    title:
      "Data Centers in Nashik | Wine & Agricultural Industry Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems delivers modern data center services in Nashik, Maharashtra on demand. Colocation and hosting solutions for wine, pharmaceutical, and agricultural industries.",
    keywords:
      "quantarock nashik, nashik data center, nashik colocation, nashik dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems nashik, nashik IT infrastructure, secure data center, wine industry, managed hosting",
    h1: "Specialized Data Centers in Nashik for Wine & Agriculture",
    intro:
      "QuantaRock Systems brings specialized data center infrastructure to Nashik on demand through our partner network, serving the wine, pharmaceutical, and agricultural sectors with secure colocation, high-speed connectivity, and industry-specific expertise.",
    features: [
      {
        title: "Wine Industry Expertise",
        description:
          "Specialized infrastructure supporting wine production, export logistics, and wine trade operations.",
      },
      {
        title: "Pharmaceutical Support",
        description:
          "Secure hosting for pharmaceutical manufacturing and supply chain management operations.",
      },
      {
        title: "Agricultural Tech Hub",
        description:
          "Connectivity solutions for agricultural technology, farming cooperatives, and agribusiness operations.",
      },
      {
        title: "Regional Connectivity",
        description:
          "Strategic location providing excellent connectivity to Maharashtra's agricultural and industrial regions.",
      },
    ],
    services: [
      "Industry-Specific Hosting",
      "Dedicated Servers",
      "Cloud Hosting",
      "Supply Chain Solutions",
      "Secure Data Storage",
      "Expert Support",
    ],
    location: {
      address: "Nashik, Maharashtra, India - 422001",
      coordinates: { lat: 19.9975, lng: 73.7898 },
    },
    cta: "Connect with QuantaRock in Nashik Today",
  },
  patna: {
    id: 17,
    city: "Patna",
    state: "Bihar",
    latitude: 25.5941,
    longitude: 85.1376,
    title:
      "Data Centers in Patna | Enterprise Colocation & Hosting Solutions | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy modern data center services in Patna, Bihar on demand. Secure colocation, dedicated servers, and cloud hosting for Eastern India businesses.",
    keywords:
      "quantarock patna, patna data center, patna colocation, patna dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems patna, patna IT infrastructure, secure data center, eastern india, managed hosting",
    h1: "Enterprise Data Centers in Patna for Eastern India",
    intro:
      "QuantaRock Systems serves Eastern India with on-demand data center deployment in Patna. Through our partner network, we offer secure colocation, dedicated servers, and cloud hosting solutions designed for businesses across Bihar, Jharkhand, and neighboring regions.",
    features: [
      {
        title: "Eastern India Gateway",
        description:
          "Strategic location serving as a gateway to Eastern India with excellent connectivity to national markets.",
      },
      {
        title: "Enterprise Infrastructure",
        description:
          "Built to enterprise standards with 99.9% uptime guarantee and redundant systems for mission-critical applications.",
      },
      {
        title: "Agricultural Sector Support",
        description:
          "Specialized infrastructure for agricultural technology and farm management systems.",
      },
      {
        title: "Regional Support",
        description:
          "Local technical team with deep expertise in Eastern India's business requirements.",
      },
    ],
    services: [
      "Enterprise Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Agricultural Tech Solutions",
      "Regional Networking",
      "24/7 Support",
    ],
    location: {
      address: "Patna, Bihar, India - 800001",
      coordinates: { lat: 25.5941, lng: 85.1376 },
    },
    cta: "Explore Data Center Solutions in Patna",
  },
  mysore: {
    id: 18,
    city: "Mysore",
    state: "Karnataka",
    latitude: 12.2958,
    longitude: 76.6394,
    title:
      "Data Centers in Mysore | Secure Colocation & Cloud Hosting | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems delivers premium data center services in Mysore, Karnataka on demand. High-performance colocation, dedicated servers, and cloud hosting for Southern India businesses.",
    keywords:
      "quantarock mysore, mysore data center, mysore colocation, mysore dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems mysore, mysore IT infrastructure, secure data center, southern india, managed hosting",
    h1: "Premium Data Centers in Mysore for Southern India",
    intro:
      "QuantaRock Systems brings world-class data center infrastructure to Mysore on demand through our partner network, serving Southern India's IT, manufacturing, and traditional sectors with secure colocation, high-performance hosting, and exceptional regional expertise.",
    features: [
      {
        title: "Southern India Hub",
        description:
          "Strategic location connecting Mysore to broader Southern India markets with optimal network routing.",
      },
      {
        title: "Manufacturing Excellence",
        description:
          "Specialized infrastructure supporting manufacturing and industrial operations with real-time connectivity.",
      },
      {
        title: "Tourism & Hospitality Ready",
        description:
          "Dedicated infrastructure for tourism, hospitality, and service industry digital solutions.",
      },
      {
        title: "High-Performance Infrastructure",
        description:
          "Advanced cooling and power systems designed for demanding workloads and applications.",
      },
    ],
    services: [
      "Enterprise Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Manufacturing Support",
      "Tourism Tech Solutions",
      "Expert Support",
    ],
    location: {
      address: "Mysore, Karnataka, India - 570001",
      coordinates: { lat: 12.2958, lng: 76.6394 },
    },
    cta: "Connect with QuantaRock in Mysore Today",
  },
  guwahati: {
    id: 19,
    city: "Guwahati",
    state: "Assam",
    latitude: 26.1445,
    longitude: 91.7362,
    title:
      "Data Centers in Guwahati | Northeast India Hosting & Colocation | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy modern data center services in Guwahati, Assam on demand. Colocation and hosting solutions for Northeast India with excellent regional connectivity.",
    keywords:
      "quantarock guwahati, guwahati data center, guwahati colocation, guwahati dedicated servers, data center quantarock, quantarock systems, data center india, colocation services, dedicated servers india, cloud hosting india, data centers india, enterprise data center, quantarock data centers, quantarock systems guwahati, guwahati IT infrastructure, secure data center, northeast india, managed hosting",
    h1: "Northeast India's Premier Data Centers in Guwahati",
    intro:
      "QuantaRock Systems treats Guwahati as the gateway to Northeast India for on-demand data center deployment. Through our partner network, we provide enterprise-class infrastructure, excellent regional connectivity, and specialized support for businesses across Assam, Meghalaya, and the Seven Sister States.",
    features: [
      {
        title: "Northeast India Gateway",
        description:
          "Strategic location serving as the connectivity hub for Northeast India with links to Southeast Asia.",
      },
      {
        title: "Regional Expertise",
        description:
          "Deep understanding of Northeast India's unique business landscape and growth opportunities.",
      },
      {
        title: "Tier 3 Infrastructure",
        description:
          "Built to Tier 3 standards with 99.9% uptime guarantee and full system redundancy.",
      },
      {
        title: "Seven Sister States Connectivity",
        description:
          "Optimized routing and dedicated support for all northeast states and border regions.",
      },
    ],
    services: [
      "Northeast Regional Colocation",
      "Dedicated Servers",
      "Cloud Hosting",
      "Regional Networking",
      "Border-Region Support",
      "24/7 Regional Support",
    ],
    location: {
      address: "Guwahati, Assam, India - 781001",
      coordinates: { lat: 26.1445, lng: 91.7362 },
    },
    cta: "Explore Data Center Solutions in Guwahati",
  },
  dubai: {
    id: 20,
    city: "Dubai",
    state: "UAE",
    latitude: 25.2048,
    longitude: 55.2708,
    title:
      "Data Centers in Dubai | Middle East Hosting & Colocation | QuantaRock Systems",
    metaDescription:
      "QuantaRock Systems can deploy premium data center capacity in Dubai, UAE on demand. Enterprise-grade colocation, cloud hosting, and dedicated servers with strategic Middle East connectivity.",
    keywords:
      "quantarock dubai, dubai data center, dubai colocation, dubai dedicated servers, data center uae, quantarock systems dubai, middle east data center, cloud hosting uae, enterprise data center dubai, managed hosting uae, dubai IT infrastructure, secure data center dubai, UAE hosting services, global connectivity dubai",
    h1: "Middle East's Premier Data Centers in Dubai",
    intro:
      "QuantaRock Systems treats Dubai as a strategic hub for the Middle East, Africa, and Asia, with on-demand data center deployment available. Through our partner network, we deliver enterprise-grade infrastructure, low-latency connectivity, and strong security for global businesses expanding in the region.",
    features: [
      {
        title: "Global Connectivity Hub",
        description:
          "Strategically located in Dubai with direct connectivity to Europe, Asia, and Africa for ultra-low latency performance.",
      },
      {
        title: "Enterprise-Grade Infrastructure",
        description:
          "State-of-the-art Tier 3+ infrastructure with high availability, redundancy, and advanced cooling systems.",
      },
      {
        title: "Middle East Market Access",
        description:
          "Ideal gateway for businesses targeting GCC countries and expanding into the Middle East market.",
      },
      {
        title: "High Security & Compliance",
        description:
          "Advanced physical and network security with compliance to international data protection standards.",
      },
    ],
    services: [
      "Colocation Services Dubai",
      "Dedicated Servers UAE",
      "Cloud Hosting Middle East",
      "Managed IT Services",
      "Disaster Recovery Solutions",
      "24/7 Global Support",
    ],
    location: {
      address: "Dubai, United Arab Emirates",
      coordinates: { lat: 25.2048, lng: 55.2708 },
    },
    cta: "Explore Data Center Solutions in Dubai",
  },
};

// Quick reference array for map visualization
export const DATA_CENTER_LOCATIONS = Object.values(ALL_DATA_CENTERS).map(
  (dc) => ({
    id: dc.id,
    city: dc.city,
    state: dc.state,
    latitude: dc.latitude,
    longitude: dc.longitude,
    address: dc.location.address,
  }),
);

// Export individual constants for backward compatibility
export const INDORE_DATA_CENTER = ALL_DATA_CENTERS.indore;
export const PUNE_DATA_CENTER = ALL_DATA_CENTERS.pune;
export const BANGALORE_DATA_CENTER = ALL_DATA_CENTERS.bangalore;
export const MUMBAI_DATA_CENTER = ALL_DATA_CENTERS.mumbai;
export const DELHI_DATA_CENTER = ALL_DATA_CENTERS.delhi;
export const HYDERABAD_DATA_CENTER = ALL_DATA_CENTERS.hyderabad;
export const KOLKATA_DATA_CENTER = ALL_DATA_CENTERS.kolkata;
export const CHENNAI_DATA_CENTER = ALL_DATA_CENTERS.chennai;
export const JAIPUR_DATA_CENTER = ALL_DATA_CENTERS.jaipur;
export const AHMEDABAD_DATA_CENTER = ALL_DATA_CENTERS.ahmedabad;
export const CHANDIGARH_DATA_CENTER = ALL_DATA_CENTERS.chandigarh;
export const NOIDA_DATA_CENTER = ALL_DATA_CENTERS.noida;
export const BHOPAL_DATA_CENTER = ALL_DATA_CENTERS.bhopal;
export const RAIPUR_DATA_CENTER = ALL_DATA_CENTERS.raipur;
export const SURAT_DATA_CENTER = ALL_DATA_CENTERS.surat;
export const NASHIK_DATA_CENTER = ALL_DATA_CENTERS.nashik;
export const PATNA_DATA_CENTER = ALL_DATA_CENTERS.patna;
export const MYSORE_DATA_CENTER = ALL_DATA_CENTERS.mysore;
export const GUWAHATI_DATA_CENTER = ALL_DATA_CENTERS.guwahati;

// Legacy support for DataCentersCities usage
export const DATA_CENTERS_CITIES = ALL_DATA_CENTERS;
